import axios from "axios";
import md5 from "js-md5";

export const url = process.env.VUE_APP_API_URL
const shareBase = `https://ticket.jifen360.com${process.env.VUE_APP_PUBLIC_PATH}/`
export const share = {
    scan: `${shareBase}scan?mark=`,
    lounge: `${shareBase}lounge?mark=`
}

export const $_ajax = axios.create({
    headers: {
        'Content-Type': 'application/json,charset=UTF-8',
    },
    // withCredentials: true
})


class axiosApi {
    #encode
    #body
    #header
    #enctry

    constructor(data) {
        this.#encode = {
            site: {
                url: `${url}/site`,
                token: "468542ba9984fb15b985defaac25b7fb"
            },
            coupon: {
                url: `${url}/third_coupon`,
                token: "lFoznEqOd457SyKH1GDPyTHHUUVtnjxL"
            }
        }
        this.#enctry = this.#encode[data.encode]
        this.#body = data.body
        this.#header = {
            method: data.method,
            sign: this.getSign(),
            times: this.timer()
        }
    }

    timer() {
        let date = new Date()
        let dateZero = (value) => {
            return parseInt(value) < 10 ? "0" + value : value;
        }

        return `${date.getFullYear()}-${dateZero(date.getMonth() + 1)}-${dateZero(date.getDate())} ${dateZero(date.getHours())}:${dateZero(date.getMinutes())}:${dateZero(date.getSeconds())}`
    }

    getSign() {
        let key = Object.keys(this.#body).sort()
        // console.log(key)
        let text = key.map(i => {
            if (this.#body[i]) {
                return `${i}${this.#body[i]}`
            } else {
                return ""
            }
        })
        text = text.filter(function (s) {
            return s && s.trim();
        })
        text = text.join("");
        return md5(`${text}${this.#enctry.token}`).toUpperCase()
    }

    param() {
        return {
            header: this.#header,
            body: this.#body
        }
    }

    send(success, fail) {
        $_ajax.post(this.#enctry.url, (this.param())).then(succ => {
            if (success) {
                success(succ.data)
            }
        }).catch(err => {
            if (fail) {
                fail(err)
            }
        })
    }
}

export default axiosApi
